import './GardenAssemblyAnimation.css';

interface GardenAssemblyAnimationProps {
	message?: string;
	subMessage?: string;
}

export default function GardenAssemblyAnimation({
	message = 'Creating your garden plan...',
	subMessage = 'We’re designing your perfect outdoor space',
}: GardenAssemblyAnimationProps) {
	return (
		<div className="garden-assembly-container" style={{ position: 'relative', zIndex: 1 }}>
			<div className="garden-assembly-scene">
				{/* Blueprint-style abstract plan being drawn */}
				<div className="ga-blueprint">
					<div className="ga-bp-shape ga-bp-rect-1" />
					<div className="ga-bp-shape ga-bp-rect-2" />
					<div className="ga-bp-shape ga-bp-circle" />
					<div className="ga-bp-path" />
				</div>
			</div>

			<div className="garden-assembly-text">
				<h5 className="mb-2">{message}</h5>
				<p className="text-muted small mb-0">{subMessage}</p>
			</div>

			{/* Progress indicator */}
			<div className="garden-progress">
				<div className="garden-progress-bar" />
			</div>
		</div>
	);
}
